// conversationActions.ts
import { bookingAvailabilityActionTypes } from "./bookingAvailabilityTypes";

export const bookingAvailabilityApiResponseSuccess = (actionType: string, data: any) => ({
  type: bookingAvailabilityActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// Action to handle API error
export const bookingAvailabilityApiResponseError = (actionType: string, error: string) => ({
  type: bookingAvailabilityActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});


export const getAvailableRoomsAction = (response: any) => ({
  type: bookingAvailabilityActionTypes.GET_AVAILABLE_ROOMS,
  payload: response
});


